import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-inbox",
  "use": "icon-leo-e1-inbox-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-inbox\">\r\n<g transform=\"translate(-61.440 -16.640) scale(1.120000)\">\r\n<path d=\"M128 320l384-176 384 176v416a64 64 0 0 1-64 64H192a64 64 0 0 1-64-64V320zm96 80v336h576V400L512 272 224 400zm288-40l208 88v56L512 416 304 504v-56l208-88z\" />\r\n  <circle cx=\"800\" cy=\"224\" r=\"112\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-inbox.svg
// module id = dUMG
// module chunks = 492